<template>
  <div>
    <div style="margin-bottom:20px;" class="homePage" v-if="!isMobile">
      <div class="bannerBox"></div>
      <div class="homePageproductImg"></div>
      <div class="pageTitle"></div>
      <div class="contentBox">
        <ul class="tabBox">
          <li v-for="(item,index) in tabList" :key="index" :class="activeIndex==index?'specialLi':''" @click="tabChange(index)">{{item.title}}</li>
        </ul>
        <el-carousel ref='carousel' :initial-index="0" indicator-position="none" :autoplay="false" arrow="never">
          <el-carousel-item v-for="(item,index) in tabList" :key="index">
            <div class="imgBox"><img :src="item.img" alt=""></div>
          </el-carousel-item>
        </el-carousel>
        <div class="circleBox">
          <div v-for="(item,index) in tabList" :key="index" :class="activeIndex==index?'specialCircleItem':''" class="circleItem"></div>
        </div>
      </div>
      <div class="qudaoBox"></div>
      <div class="priceBox clearfix"></div>
      <div class="contentPriceBox">
        <img class="contentImg" src="https://htmlqiniu.jihex.com/priceContentImg.png" alt="">
        <div @click="cooperateClick" class="cooperateBtn"></div>
        <div @click="tryOutBtnClick" class="tryOutBtn"></div>
      </div>
      <div class="cooperateBox">
        <el-dialog title="" width="650px" :visible.sync="cooperateDia">
          <img class="cooperateImg" src="https://htmlqiniu.jihex.com/%E6%B7%B1%E5%BA%A6%E5%90%88%E4%BD%9C_%E8%81%94%E7%B3%BB%E5%95%86%E5%8A%A1%402x.png" alt="">
        </el-dialog>
      </div>
    </div>
    <div class="mobilePage" v-else>
      <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_1.png" alt="" />
      <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_2.png" alt="" />
      <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_3.png" alt="" />
      <div class='moreBtnBox'>
          <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_4.png" alt="" /> 
          <div class="moreBtn" @click="clickIsShop()">
              <span>了解更多</span>
              <span class="arrows"></span>
          </div>
      </div>
      <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_5.png" alt="" />
      <img src="https://htmlqiniu.jihex.com/saas/mobile/homePage_6.png" alt="" />
      <div style="height: 1.28rem;"></div>
      <div class="fixBar">
        <div class="iconImgBox" @click="clickCounsel()">
          <img class="iconImg" src="https://htmlqiniu.jihex.com/saas/mobile/counsel.png" alt="" />
          <span>咨询</span>
        </div>
        <button style="margin-right: .2rem;" @click="clickIsShop()">我是商家</button>
        <button @click="clickIsKol()">我是达人</button>
      </div>
    </div>
  </div>
  
</template>
<script>
import webHost from '@/api/config.js'
export default {
  data () {
    return {
      activeIndex:0,
      index:0,
      tabList:[{
        title:'酒店/民宿',
        img:'https://htmlqiniu.jihex.com/serve_hotelImg.png',
      },{
        title:'在线旅行社 (MINIOTA)',
        img:'https://htmlqiniu.jihex.com/serve_travel.png',
      },{
        title:'带货达人',
        img:'https://htmlqiniu.jihex.com/%E6%9C%8D%E5%8A%A1%E5%AF%B9%E8%B1%A1_%E8%BE%BE%E4%BA%BA%E5%B8%A6%E8%B4%A7.png',
      },{
        title:'垂直流量主',
        img:'https://htmlqiniu.jihex.com/serve_tab2.png',
      },{
        title:'新流量生态商家',
        img:'https://htmlqiniu.jihex.com/%E6%9C%8D%E5%8A%A1%E5%AF%B9%E8%B1%A1_%E6%96%B0%E6%B5%81%E9%87%8F%E7%94%9F%E6%80%81%E5%95%86%E5%AE%B6.png',
      }],
      cooperateDia:false,
      title: '太目',
      isMobile: false
    }
  },
  methods:{
    clickCounsel(){
      this.$router.push('/counsel')
    },
    clickIsKol(){
      window.location.href = 'https://www.timesaas.cn/html/v1/login/undertake'
    },
    clickIsShop(){
      window.location.href = 'https://timesaas.yuque.com/epkxyy/sep2nk?'
    },
    tabChange(index) {
      this.activeIndex = index
      this.$refs.carousel.setActiveItem(this.activeIndex)
    },
    cooperateClick() {
      window.open('https://agent.timesaas.cn/agent/15?bms=no&user_question=我想联系太目销售', '_blank')
      // this.cooperateDia = true
    },
    tryOutBtnClick() {
      window.open(`${webHost}/#/login?isRegisterShow=true`)
    },
  },
  beforeCreate () {
    document.title = this.$route.meta.title
  },
  created() {
    let roleList = [{roleId:5,roleName:'name1'},{roleId:6,roleName:'name6'}]
    let arr = []
    roleList.forEach(i=>{
         arr.push(i.roleId)
      })
    roleList = arr
    // console.log(roleList)
  },
  mounted(){
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
      this.isMobile = true
      console.log('iPhone');
    } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
      this.isMobile = true
      console.log('Android');
    } else { //pc
      this.isMobile = false
      console.log('pc');
    };
  }
}
</script>
<style lang="scss" scoped>
.bannerBox {
  width: 100%;
  height: 420px;
  min-width: 1200px;
  background: url(https://htmlqiniu.jihex.com/homepageBanner.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.homePageproductImg {
  width: 100%;
  min-width: 1200px;
  height: 701px;
  background: url(https://htmlqiniu.jihex.com/newWebsiteImg6.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.pageTitle {
    width: 100%;
    min-width: 1200px;
    height: 172px;
    background: url(https://htmlqiniu.jihex.com/%E6%9C%8D%E5%8A%A1%E5%AF%B9%E8%B1%A1title.png);
    background-repeat: no-repeat;
    background-position:center center;
    background-size: cover;
 }
.qudaoBox {
  width: 100%;
  min-width: 1200px;
  height: 800px;
  background: url(https://htmlqiniu.jihex.com/newWebsiteImg5.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.priceBox {
  width: 100%;
  min-width: 1200px;
  height: 610px;
  background: url(https://htmlqiniu.jihex.com/priceBanner.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
  display:table;
}
.contentPriceBox {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  margin-top: -135px;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 40px;
  .contentImg {
    width: 1180px;
    height: 606px;
    border-radius: 10px;
    box-shadow: 0px 0px 40px 0px rgba(42, 54, 65, 0.04);
  }
  .cooperateBtn {
    width: 192px;
    height: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(-202px);
    top: -98px;
    &:hover {
      cursor: pointer;
    }
  }
  .tryOutBtn {
    width: 192px;
    height: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(10px);
    top: -98px;
    &:hover {
      cursor: pointer;
    }
  }
}
.contentBox {
  width: 1200px;
  padding: 0px 10px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  ul,li {
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  .tabBox {
    width: 1200px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    li {
      height: 32px;
      background: #FFFFFF;
      box-shadow: 0px 3px 16px 0px rgba(42, 54, 65, 0.08);
      border-radius: 16px;
      padding: 0px 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #606266;
      margin-right: 16px;
      &:hover {
        cursor: pointer;
        color: #FFFFFF;
        font-weight: bold;
        background: linear-gradient(90deg, #007AFF 0%, #007AFF 100%);
        box-shadow: 0px 3px 16px 0px rgba(42, 54, 65, 0.08);
      }
    }
    .specialLi {
      color: #FFFFFF;
      font-weight: bold;
      background: linear-gradient(90deg, #007AFF 0%, #007AFF 100%);
      box-shadow: 0px 3px 16px 0px rgba(42, 54, 65, 0.08);
    }
    :last-child {
      margin-right: 0px;
    }
  }
  .imgBox {
    width: 1180px;
    height: 330px;
    border-radius: 10px;
    img {
      width: 1180px;
      height: 330px;
      border-radius: 10px;
      display: block;
      box-shadow: 0px 0px 40px 0px rgba(42, 54, 65, 0.04);
    }
  }
  .circleBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 98px;
    .circleItem {
      width: 8px;
      height: 8px;
      background: #D6E2FF;
      border-radius: 50%;
      margin-right: 12px;
    }
    :last-child {
      margin-right: 0px;
    }
    .specialCircleItem {
      background: #6694FF;
    }
  }
}
.clearfix::before{
  content: ”;
  display: table;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .cooperateImg {
    width: 650px;
    height: 224px;
    display: block;
  }
  //移动端样式
  .mobilePage{
    position: relative;
    img{
      width: 7.5rem;
      vertical-align: top;
    }
    .moreBtnBox{
      position: relative;
      .moreBtn{
        width: 2.03rem;
        height: .68rem;
        background: linear-gradient(180deg, #60A0FF 0%, #237CFF 100%);
        border-radius: .36rem;
        position: absolute;
        left: .49rem;
        bottom: 3.8rem;
        font-size: .26rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: .4rem;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: .4rem;
        .arrows{
            margin-left: .12rem;
            border: .075rem solid transparent;
            border-right: 0;
            border-left: .1rem solid #fff;
        }
      }
    }
    .fixBar{
      width: 100%;
      height: 1.28rem;
      background-color: #fff;
      z-index: 99;
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconImgBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: .46rem;
        .iconImg{
          width: 0.6rem;
          height: 0.6rem;
          vertical-align: top;
          flex-shrink: 0;
        }
        span{
          flex-shrink: 0;
          font-size: .2rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #1876F0;
          line-height: .3rem;
        }
      }
      button{
        outline: 0;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        width: 2.6rem;
        height: .8rem;
        border-radius: .4rem;
        border: .02rem solid #A3C8F9;
        font-size: .26rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1876F0;
        line-height: .4rem;
      }
    }
  }
</style>
<style>
.homePage .el-carousel__container {
  height: 330px;
  border-radius: 10px;
}
.homePage .el-carousel {
  box-shadow: 0px 0px 40px 0px rgba(42, 54, 65, 0.04);
}
.homePage .el-carousel__item:nth-child(odd) {
  background: none;
}
.cooperateBox .el-dialog__body {
  padding: 0px;
  padding-top: 16px;
  padding-bottom: 30px;
}
/* https://htmlqiniu.jihex.com/%E6%B7%B1%E5%BA%A6%E5%90%88%E4%BD%9C_%E8%81%94%E7%B3%BB%E5%95%86%E5%8A%A1%402x.png */
</style>



// WEBPACK FOOTER //
// src/view/homePage.vue